/**
 * Утилита для работы с localStorage и sessionStorage.
 */
const Storage = {
  /**
   * Сохраняет данные в localStorage или sessionStorage.
   *
   * @param {string} key - Ключ для сохранения данных.
   * @param {*} value - Значение, которое будет сохранено.
   * @param {boolean} [session=false] - Если true, данные сохраняются в sessionStorage, иначе в localStorage.
   */
  set(key, value, session = false) {
    const storage = session ? sessionStorage : localStorage;
    storage.setItem(key, JSON.stringify(value));
  },

  /**
   * Получает данные из localStorage или sessionStorage.
   *
   * @param {string} key - Ключ, по которому сохранялись данные.
   * @param {boolean} [session=false] - Если true, данные ищутся в sessionStorage, иначе в localStorage.
   * @returns {*} Возвращает распарсенные данные или null, если ключ не найден.
   */
  get(key, session = false) {
    const storage = session ? sessionStorage : localStorage;
    const data = storage.getItem(key);
    return data ? JSON.parse(data) : null;
  },

  /**
   * Удаляет элемент из localStorage или sessionStorage.
   *
   * @param {string} key - Ключ удаляемого элемента.
   * @param {boolean} [session=false] - Если true, удаление происходит из sessionStorage, иначе из localStorage.
   */
  remove(key, session = false) {
    const storage = session ? sessionStorage : localStorage;
    storage.removeItem(key);
  },

  /**
   * Очищает полностью localStorage или sessionStorage.
   *
   * @param {boolean} [session=false] - Если true, очищается sessionStorage, иначе localStorage.
   */
  clear(session = false) {
    const storage = session ? sessionStorage : localStorage;
    storage.clear();
  }
};

window.Storage = Storage;